import script from "./StatisticPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./StatisticPage.vue?vue&type=script&setup=true&lang=ts"

import "./StatisticPage.vue?vue&type=style&index=0&id=018ffe7a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-018ffe7a"]])

export default __exports__